// GET EXTRANET NOTIFICATION
export const GET_EXTRANET_NOTIFICATION = 'GET_EXTRANET_NOTIFICATION';
export const GET_EXTRANET_NOTIFICATION_SUCCESS = 'GET_EXTRANET_NOTIFICATION_SUCCESS';
export const GET_EXTRANET_NOTIFICATION_FAILED = 'GET_EXTRANET_NOTIFICATION_FAILED';

// READ EXTRANET NOTIFICATION
export const READ_EXTRANET_NOTIFICATION = 'READ_EXTRANET_NOTIFICATION';
export const READ_EXTRANET_NOTIFICATION_SUCCESS = 'READ_EXTRANET_NOTIFICATION_SUCCESS';
export const READ_EXTRANET_NOTIFICATION_FAILED = 'READ_EXTRANET_NOTIFICATION_FAILED';
